import React from 'react';
import ClientPhone from '../shared/ClientPhone';
import { phoneFormat, stripPhoneNumber } from '../shared/util';
import NJRTermsDocument from '../../assets/Documents/NJR/njr-serviceplan-terms.pdf';
import styles from './Faq.module.css';

export const brandFaqs = {
    NJR: [
        {
            title: 'About Service Plans',
            faqs: [
                {
                    // ANSWER MAY BE A SINGLE STRING, OR MAY BE AN ARRAY OF STRINGS, WHERE EACH NEW STRING REPRESENTS A NEW PARAGRAPH
                    question: 'Why buy a Service Plan?',
                    answer: " Over time, appliances may breakdown and require repairs or may need to be replaced. These breakdowns can be unexpected and once the manufacturer's warranty expires addressing them may be costly. A Service Plan will help cover repairs for your covered essesntial systems and appliances when they breakdown due to normal wear and tear. With a Service Plan, if a covered incident occurs, we'll help repair or replace the appliance."
                },
                {
                    question:
                        'Once a Service Plan is purchased, how long will it take to receive the actual Service Plan contract?',
                    answer: 'If a valid email address is provided, we will send the Service Plan via email within 7-14 business days (Monday-Friday) after purchase. If we do not have an email address, we will send the Service Plan via United States Postal Service (USPS) within 30 days after purchase.'
                },
                {
                    question: 'What are the different payment options?',
                    answer: 'A Service Plan can either be paid monthly or yearly. If you choose monthly, payments will be automatically charged using the current payment method on file (ACH account or credit card) every 30 days. Yearly plans will automatically renew each year.'
                },
                {
                    question: 'What payment methods can be used to purchase a plan?',
                    answer: 'We will accept an ACH account, credit card or debit card as a form of payment. If you are paying with a credit card or debit card, we accept Discover, MasterCard or Visa for payment. If you are paying with an ACH account, we will accept a checking or savings account for payment.'
                },
                {
                    question: 'What is a trade service fee?',
                    answer: 'A trade service fee is the fee you pay when you setup a claim for your appliance. The fee is separate from any trip or diagnosis fees, which may be charged against your benefit limit. You choose the trade service fee amount (either $25 or $55) when you purchase your plan. The plan costs vary based on the trade service fee you chose.'
                },
                {
                    question: 'Will I pay  a trade service fee for each visit?',
                    answer: 'No, the trade service fee is for each claim that is filed.'
                },
                {
                    question: 'Can a Service Plan be purchased if the product is used in a business?',
                    answer: [
                        <>
                            Products used in a commercial setting are not eligible for coverage. See&nbsp;
                            <a
                                className={styles.link}
                                onClick={() => window.open(NJRTermsDocument)}
                            >
                                terms and conditions
                            </a>{' '}
                            for complete details.
                        </>
                    ]
                }
            ]
        },
        {
            title: 'Plan Options',
            faqs: [
                {
                    // ANSWER MAY BE A SINGLE STRING, OR MAY BE AN ARRAY OF STRINGS, WHERE EACH NEW STRING REPRESENTS A NEW PARAGRAPH
                    question: 'What are the coverage options?',
                    answer: 'We currently offer three plan options – Kitchen Appliance Plan, Laundry Appliance Plan, and Total Appliance Plan (which includes both Kitchen and Laundry Plan coverages).'
                },
                {
                    question: 'What is covered in the Kitchen Appliance Plan?',
                    answer: 'Coverage is provided for: One cooking product (either a range, oven or cooktop), dishwasher, kitchen exhaust fan, garbage disposal, built-in microwave, refrigerator (does not include ice maker), and interior electrical system.'
                },
                {
                    question: 'What is covered in the Laundry Appliance Plan?',
                    answer: 'Coverage is provided for: One washer and one dryer.'
                },
                {
                    question: 'Can I purchase the Kitchen and Laundry Plans at the same time?',
                    answer: 'Yes, you can purchase a Total Appliance Plan which includes both the Kitchen and Laundry Plan coverages!'
                },
                {
                    question: 'Can I add on any additional appliances or products?',
                    answer: "Yes,  if you purchase the Kitchen Appliance Plan  or the Total Appliance Plan, for an additional cost, you can add coverage for a second cooking product (either a range, oven or cooktop), a second built-in microwave, a second refrigerator and/or a standalone freezer. Note: The refrigerator's ice maker components are not covered under these plans."
                },
                {
                    question: 'Can I cancel my Service Plan once I have purchased it?',
                    answer: [
                        <>
                            Yes, you may cancel this Agreement at any time for any reason. You may cancel this Agreement
                            via phone by calling&nbsp;
                            <ClientPhone department='customerService' />. If you cancel this Agreement without making a
                            claim within the later of (a) 30 days from the Purchase Date; (b) 10 days from your initial
                            receipt of this Agreement and Certificate of Coverage following the Purchase Date; or (c) 20
                            days of our intially sending you the Agreement and Certificate of Coverage following the
                            Purchase Date ("Free Look Period"), you will receive a refund of the full purchase. If you
                            cancel this Agreement within 30 days from the Purchase Date after making a claim or after
                            the Free Look Period, you will be refunded the remaining days of coverage on monthly
                            prorated basis, less costs for service performed and claims paid. Monthly contracts will not
                            generate a refund and will cancel your coverage after the current month's coverage expires.
                        </>
                    ]
                }
            ]
        },
        {
            title: 'Filing A Claim',
            faqs: [
                {
                    // ANSWER MAY BE A SINGLE STRING, OR MAY BE AN ARRAY OF STRINGS, WHERE EACH NEW STRING REPRESENTS A NEW PARAGRAPH
                    question: 'When can a claim be filed?',
                    answer: [
                        <>
                            There is a 30 day WAIT PERIOD, from the date of the Service Plan purchase. After 30 days you
                            can file a claim, but please note that breakdowns due to rust or corrosion will not be
                            covered for 60 days after the purchase date. Further, plan does not cover any pre-existing
                            conditions or failures that occur prior to or during the wait period, nor will coverage be
                            provided for products covered by a manufacturer's warranty. See&nbsp;
                            <a
                                className={styles.link}
                                onClick={() => window.open(NJRTermsDocument)}
                            >
                                terms and conditions
                            </a>{' '}
                            for complete details.
                        </>
                    ]
                },
                {
                    question: 'How is a claim filed?',
                    answer: [
                        <>
                            If a problem occurs, call toll-free <ClientPhone department='claim' /> and explain the
                            issue.
                        </>
                    ]
                },
                {
                    question: 'When is the trade service fee paid?',
                    answer: ' The trade service fee is due when you file a claim. The trade service fee is charged to setup the claim and is seperate from any trip or diagnosis fees, which may be charged against your benefit limit. If you are submitting a claim for more than one appliance, the trade service fee will be charged for each claim. We accept Visa, MasterCard, Discover or American Express in the form of a credit or debit for payment.'
                },
                {
                    question: 'How is service scheduled?',
                    answer: [
                        <>
                            Call <ClientPhone department='claim' /> to schedule service.
                        </>
                    ]
                },
                {
                    question: 'Who will service the product?',
                    answer: 'Service will be scheduled at your convenience with an authorized technician in your area.'
                },
                {
                    question: 'If my appliance cannot be repaired, how will it be replaced?',
                    answer: (
                        <>
                            Our goal is to successfully resolve all valid claims. A repair is not always possible. We
                            may either exchange your product with a replacement that has similar features and
                            functionality or offer a cash settlement or buyout up to the service plan’s benefit actual
                            retail. Per 12-month period, we will cover up to $800 per appliance or system that is 10
                            years old or less in age at the time of the breakdown and $500 per appliance or system that
                            is over 10 years old at the time of breakdown, not to exceed the aggregate limit of $5,000
                            (“Benefit Limit”). This Benefit Limit includes any costs for trip, diagnosis, or
                            repair/replacement/cash settlement or installation. Any cash settlement or buyout will be
                            reduced by any cost of trip or diagnosis we have incurred. Please see our complete&nbsp;
                            <a
                                className={styles.link}
                                onClick={() => window.open(NJRTermsDocument)}
                            >
                                terms and conditions
                            </a>{' '}
                            for more details.
                        </>
                    )
                }
            ]
        }
    ],

    AIG: [
        {
            title: '',
            faqs: [
                {
                    qustion: '',
                    answer: ''
                }
            ]
        }
    ]

    // ONLY FOR TESTING. YOU KNOW, HAVE SOME FUN! 😁🎈
    // aig: [
    //     {
    //         title: 'Lorems',
    //         faqs: [
    //             {
    //                 question: 'Bacon Ipsum?',
    //                 // ANSWER MAY BE A SINGLE STRING, OR MAY BE AN ARRAY OF STRINGS, WHERE EACH NEW STRING REPRESENTS A NEW PARAGRAPH
    //                 answer: [
    //                     "Bacon ipsum dolor amet kielbasa t-bone tail kevin. Brisket do tempor ball tip jowl. Est tongue capicola enim eu pork chop burgdoggen. Flank dolor cow fugiat et corned beef ad sed kevin pastrami sirloin shoulder. In ground round buffalo, nulla spare ribs et commodo. Ut ham hock ut irure ipsum occaecat.",
    //                     "Bacon ipsum dolor amet andouille tenderloin ground round pork belly, shank swine kevin. Chuck turducken cow burgdoggen kevin pancetta corned beef landjaeger tenderloin tail. Rump venison shankle chicken. Meatball sirloin meatloaf, doner leberkas bresaola boudin cupim. Leberkas sausage pork loin prosciutto beef burgdoggen kevin. Chislic biltong pork belly short ribs."
    //                 ]
    //             },
    //             {
    //                 question: 'Cheese Ipsum?',
    //                 answer: "I love cheese, especially cheeseburger fondue. Jarlsberg cheesy feet jarlsberg goat manchego cheesy feet airedale babybel. Cream cheese boursin cheesecake cheese and wine cheesy feet pecorino cottage cheese croque monsieur. Manchego goat emmental fromage mascarpone croque monsieur mascarpone cheesecake. Cheesy feet."
    //             },
    //             {
    //                 question: 'Coffee Ipsum?',
    //                 answer: 'Dripper, macchiato, spoon caramelization doppio plunger pot beans cream. So, latte saucer, cup froth rich con panna latte con panna bar  extraction. Wings eu coffee, and filter foam seasonal aromatic. Grinder eu, dripper chicory, iced wings turkish sit seasonal. Carajillo iced seasonal turkish black eu redeye, frappuccino cup half and half wings strong.'
    //             },
    //             {
    //                 question: 'Pikachu Ipsum?',
    //                 answer: 'Pikachu ipsum dolor sit amet jolteon quis articuno seaking ivysaur, eevee labore. Anim fugiat shellder tempor aute dolore. Ut dolore hypno excepteur proident. Laboris do dragonite dolore eiusmod. '
    //             }
    //         ]
    //     },
    //     {
    //         title: 'Hedgehogs',
    //         faqs: [
    //             {
    //                 question: 'Are all hedgehogs fast?',
    //                 answer: 'Some might say supersonic',
    //             },
    //             {
    //                 question: 'Are there any blue hedgehogs?',
    //                 answer: 'While some hedgehogs are allegedly blue, many in the the larger hedgehog community dislikes the assumption that they should also be blue'
    //             },
    //             {
    //                 question: 'Do hedgehogs like hedges? And are they related to other hogs?',
    //                 answer: 'No.'
    //             }
    //         ]
    //     }
    // ],
};
